// extracted by mini-css-extract-plugin
export default {"hideTooltip":"p_-z","fadeIn":"q_-z","delay":"r_-z","recommendedSizeTooltip":"s_-z"};